import { integrationId } from '../fixture-ids';

export const integrationEntries = {
  INTEGRATION_CREATED: {
    entity: 'integration',
    identity: 'record',
    idKeys: ['integrationId'],
    renderMode: 'diff',
    createsRecord: true,
  },
  INTEGRATION_UPDATED: {
    entity: 'integration',
    identity: 'record',
    idKeys: ['integrationId'],
    renderMode: 'diff',
    createsRecord: false,
  },
  INTEGRATION_DELETED: {
    entity: 'integration',
    identity: 'record',
    idKeys: ['integrationId'],
    renderMode: 'diff',
    createsRecord: false,
  },
};

export const integrationFixtures = {
  INTEGRATION_CREATED: {
    action: 'INTEGRATION_CREATED',
    debugData: {
      integrationId,
      integrationName: 'Google Analytics 4',
      starterkitId: 'sk-ga4-v1',
    },
  },
  // Legacy INTEGRATION_UPDATED rows carry no starterkitVersion: the legacy builder destructured
  // it but useUpdateIntegration.js never supplied it, so it never reached the jsonb.
  INTEGRATION_UPDATED: {
    action: 'INTEGRATION_UPDATED',
    debugData: {
      integrationId,
      integrationName: 'Google Analytics 4',
      starterkitVersion: '2.4.1',
    },
  },
  INTEGRATION_DELETED: {
    action: 'INTEGRATION_DELETED',
    debugData: {
      integrationId,
      integrationName: 'Google Analytics 4',
    },
  },
};
